import { lazy } from "react";

export const ContactPageContent = lazy(() => import("./ContactPageContent"));
export const ContactPageForm = lazy(() => import("./ContactPageForm"));
